<template>
<section>
	<simplert useRadius=true
	          useIcon=true
	          ref="simplert">
	</simplert>
	<div class="chose-wrap unfixed">
		<ul>
            <li @click="selectHeight()">
                <div class="icon-height">您的身高</div>
                <div class="icon-arrow-right">
                    <span v-if="defaultHeight">{{defaultHeight}}CM</span>
                </div>
            </li>
			<li @click="selectWeight()">
				<div class="icon-weight">您的体重</div>
				<div class="icon-arrow-right">
					<span v-if="defaultWeight">{{defaultWeight}}kg</span>
				</div>
			</li>
			<li @click="selectMotion()">
				<div class="icon-motion">活动强度</div>
				<div class="icon-arrow-right motion">{{defaultMotion}}</div>
			</li>
		</ul>
	</div>

	<div class="calculate-link" @click="goresult()">计算能量</div>

</section>
</template>

<script>
  import countTo from 'vue-count-to'
  import Picker from 'better-picker'
  import Simplert from 'vue2-simplert'
  export default {
    components: { countTo ,Simplert},
    computed : {
      dataHeight () {
        return this.$store.state.dataHeight
      },
      dataWeight () {
        return this.$store.state.dataWeight
      }
    },
    data () {
      return {
        defaultWeight:0,
        defaultMotion:'',
        defaultHeight:'',
        motionNum:0,
        needed:0,
        sportType:[],
        sportSubType:[]
      }
    },
    head: {
        title: function () {
            return {
                inner: '一日所需能量',
                separator: ' ', 
                complement: ' '
            }
        }
    },
    created(){
        this.axios.get(sport_type_api + '0').then((response) => {
            //console.log(response.data)
            var data_motion = []
            var len = response.data.length
            for(let i = 0; i<len;i++){
                data_motion[i] = {
                    text:response.data[i].name,
                    value:response.data[i].id
                }
                //
                this.axios.get(sport_type_api + response.data[i].id).then((responsefood) => {
                    var subtypes = responsefood.data
                    var sublen   = responsefood.data.length
                    var subTypeArr = []
                    for(var j = 0; j<sublen; j++){
                        subTypeArr[j] = {
                            text:subtypes[j].name,
                            value:subtypes[j].id
                        }
                    }
                    if(subTypeArr.length == 0){
                        subTypeArr[0] = {
                            text:'卧床休息',
                            value:'卧床休息'
                        }
                    }
                    this.sportSubType[i] = subTypeArr
                })
                ///
            }
            this.sportType = data_motion
        })
    },
    methods:{
    	selectWeight(){
    		// picker height
    		var picker1 = new Picker({
				data: [this.dataWeight],
				selectedIndex: [0],
				title: '选择体重'
			});
			var _that = this
			picker1.on('picker.select', function (selectedVal, selectedIndex) {
				_that.defaultWeight = _that.dataWeight[selectedIndex[0]].value
			})
			picker1.show()
    		// end picker height
    	},
        selectHeight(){
            // picker weight
            var picker3 = new Picker({
                data: [this.dataHeight],
                selectedIndex: [0],
                title: '选择身高'
            });
            var _that = this
            picker3.on('picker.select', function (selectedVal, selectedIndex) {
                _that.defaultHeight = _that.dataHeight[selectedIndex[0]].value

            })
            picker3.show()
            // end picker weight
        },
    	selectMotion(){
            var interv;
            interv = setInterval(() => {
                if(this.sportSubType.length > 1){
                    clearInterval(interv)
                    // picker motion
                    var picker2 = new Picker({
                        data: [this.sportType,this.sportSubType[0]],
                        selectedIndex: [0,1],
                        title: '选择活动强度'
                    });
                    var _that = this
                    picker2.on('picker.change', function (index, selectedIndex) {
                        if(index == 0){
                            var second = _that.sportSubType[selectedIndex]
                            picker2.refillColumn(1, second);
                        }

                    });
                    picker2.on('picker.select', function (selectedVal, selectedIndex) {
                        _that.defaultMotion = _that.sportType[selectedIndex[0]].text
                        switch(_that.defaultMotion){
                            case '卧床休息':
                                _that.motionNum = 0
                                break;
                            case '轻体力劳动':
                                _that.motionNum = 1
                                break;
                            case '中体力劳动':
                                _that.motionNum = 2
                                break;
                            case '重体力劳动':
                                _that.motionNum = 3
                                break;
                        }
                    })
                    picker2.show()
                    // end picker motion
                }
            }, 50)
        		
    	},
    	goresult(){
            if(!this.defaultHeight){
                let obj = {
                    message: '请选择身高',
                    type: 'error',
                    customCloseBtnText:'确定'
                }
                this.$refs.simplert.openSimplert(obj)
                return false
            }
    		if(!this.defaultWeight){
    			let obj = {
				    message: '请选择体重',
				    type: 'error',
				    customCloseBtnText:'确定'
				}
				this.$refs.simplert.openSimplert(obj)
				return false
    		}
    		if(!this.defaultMotion){
    			let obj = {
				    message: '请选择活动强度',
				    type: 'error',
				    customCloseBtnText:'确定'
				}
				this.$refs.simplert.openSimplert(obj)
				return false
    		}
            var ideal_weight = this.defaultHeight - 105 // 理想体重(kg)
            var float_weight = ideal_weight * 10 / 100  // 浮动体重(kg)
            var your_figure = 1 // 0消瘦 1正常 2肥胖
            if(this.defaultWeight > (ideal_weight + float_weight * 2)){
                your_figure = 2
            }else if(this.defaultWeight < (ideal_weight - float_weight * 2)){
                your_figure = 0
            }
            switch(your_figure){
                case 0:
                    if(this.motionNum == 0){
                        var enl = this.defaultWeight * 20
                        var enr = this.defaultWeight * 25
                        this.needed = (enl + enr) / 2
                    }else if(this.motionNum == 1){
                        this.needed = this.defaultWeight * 35
                    }else if(this.motionNum == 2){
                        this.needed = this.defaultWeight * 40
                    }else if(this.motionNum == 3){
                        var enl = this.defaultWeight * 40
                        var enr = this.defaultWeight * 45
                        this.needed = (enl + enr) / 2
                    }
                    break;
                case 1:
                    if(this.motionNum == 0){
                        var enl = this.defaultWeight * 10
                        var enr = this.defaultWeight * 20
                        this.needed = (enl + enr) / 2
                    }else if(this.motionNum == 1){
                        this.needed = this.defaultWeight * 30
                    }else if(this.motionNum == 2){
                        this.needed = this.defaultWeight * 35
                    }else if(this.motionNum == 3){
                        this.needed = this.defaultWeight * 40
                    }
                    break;
                case 2:
                    if(this.motionNum == 0){
                        this.needed = this.defaultWeight * 15
                    }else if(this.motionNum == 1){
                        var enl = this.defaultWeight * 20
                        var enr = this.defaultWeight * 25
                        this.needed = (enl + enr) / 2
                    }else if(this.motionNum == 2){
                        this.needed = this.defaultWeight * 30
                    }else if(this.motionNum == 3){
                        this.needed = this.defaultWeight * 35
                    }
                    break;
            }
            this.needed = Math.round(this.needed / 100) * 100
            this.$router.replace({ 
                path: '/dayneedresult',
                query: { energy_required:this.needed}
            });
    	}
    }
  }
</script>


// WEBPACK FOOTER //
// fillform.vue?d9bdd7a4